import Row from '@components/Row';
import Stepper from '@components/Stepper';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import usePriceUnit from '@hooks/item/usePriceUnit';
import useAppCustom from '@hooks/useAppCustom';
import { useItemActivityId } from '@store/item/context/ItemActivityContext';
import useCalculatedOrder from '@store/item/hooks/useCalculatedOrder';
import useItemQuantity from '@store/item/hooks/useItemQuantity';
import { itemActions } from '@store/item/itemSlice';
import { useDispatch } from 'react-redux';

interface Props {
    itemId: string;
}

function AmountRow({ itemId }:Props) {
    const { itemMaxQuantity } = useAppCustom().item;
    const dispatch = useDispatch();
    const activityId = useItemActivityId();
    const itemQuantity = useItemQuantity(itemId);
    const { totalAmount } = useCalculatedOrder();
    const priceUnit = usePriceUnit();
    return (
        <Container justify='space-between'>
            <Stepper value={itemQuantity}
                max={itemMaxQuantity}
                min={1}
                increase={() => dispatch(itemActions.updateItemQuantity({
                    activityId, itemId, amount: 1,
                }))}
                decrease={() => dispatch(itemActions.updateItemQuantity({
                    activityId, itemId, amount: -1,
                }))} />
            <Text size='display' fontWeight='bold' color={colors.textError}>
                {totalAmount.toLocaleString()}{priceUnit}
            </Text>
        </Container>
    );
}

const Container = styled(Row)`
    padding: 0  0 var(--spacing-5);
`;

export default AmountRow;
